// extracted by mini-css-extract-plugin
module.exports = {"form":"magic-login_form__1m3lL"};